<ul class="lang-switcher lang-switcher-{{ type }} inline-block relative">
  <li *ngFor="let language of languages" class="item inline-block z-10 {{ lang === language ? 'active' : 'inactive' }}">
    <span (click)="switchLang(language)">
      {{ language | uppercase }}
      <svg
        *ngIf="lang === language && type === langSwitcherType.dropDown"
        class="svg-arrow"
        width="10"
        height="5"
        viewBox="0 0 10 5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 0L5 5L10 0H0Z" fill="#ED0000" />
      </svg>
    </span>
  </li>
</ul>
